import { useState } from 'react'
import { LiveBarcode } from '@/components/ui/live-barcode'

interface InlineBarcodeProps {
  onDetect: (code: string) => void
}

export function InlineBarcode({ onDetect }: InlineBarcodeProps) {
  const [error, setError] = useState<string | null>(null)
  const [latest, setLatest] = useState('')

  return (
    <div className="overflow-hidden rounded-lg border border-border bg-zinc-950">
      <LiveBarcode
        className="h-52 w-full"
        onError={setError}
        onDetect={(code) => {
          setError(null)
          setLatest(code)
          onDetect(code)
        }}
      />
      <div className="bg-zinc-900 px-3 py-2 text-xs text-zinc-200">
        {error || latest || 'Point at the code, or tap it to focus'}
      </div>
    </div>
  )
}
